import siteInfoMigrations from './siteInfo';
import layoutItemMigrations from './layoutItem';
import { mapValues } from 'lodash';

/**
* Version 2 migrations for the event website.
* - Migrate new shared config settings into siteInfo for EventIdentityConfirmation widgets.
* - Migrate new style settings onto EventIdentityConfirmation widgets.
*/
export default function v2(website) {
  return {
    ...website,
    eventVersion: 2,
    siteInfo: siteInfoMigrations(website.siteInfo),
    layoutItems: mapValues(website.layoutItems, layoutItemMigrations)
  };
}
